import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from '../../../shared/Link/Link';

import Price from '../../../shared/Price/Price';
import ProdottoRiepilogo from './ProdottoRiepilogo/ProdottoRiepilogo';

import './Riepilogo.scss';

class Riepilogo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      discount: 5,
    };
  }

  renderCartTotal() {
    let cartTotal = this.props.cart.reduce((total, product) => {
      return total + product.price * product.quantity;
    }, 0);

    if (this.state.value) {
      return cartTotal - this.state.discount;
    }

    return cartTotal;
  }

  renderCartItems() {
    return this.props.cart.map(product => {
      return (
        <ProdottoRiepilogo
          key={product.id}
          product={product}
          uiVariantButton={this.props.uiVariantButton}
        />
      );
    });
  }

  render() {
    return (
      <div className="riepilogo">
        <table className="table">
          <thead>
            <tr>
              <td colSpan="2">Prodotto</td>
              <td>Quantità</td>
              <td className="text-right">Prezzo</td>
            </tr>
          </thead>
          <tbody>
            {this.renderCartItems()}
            <tr>
              <td />
              <td colSpan="2">Codice sconto SALE20</td>
              <td className="text-right">
                - <Price amount={this.state.discount} />
              </td>
            </tr>
            <tr>
              <td />
              <td colSpan="2">Spedizione rapida con corriere espresso</td>
              <td className="text-right">
                <Price amount={12} />
              </td>
            </tr>
            <tr>
              <td />
              <td colSpan="2">Pagamento con PayPal</td>
              <td className="text-right">Gratis</td>
            </tr>
            <tr>
              <td colSpan="6" className="total">
                <span className="text">Totale:</span>
                <span className="amount">
                  <Price amount={this.renderCartTotal()} />
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <div className="buttons">
          <Link to="/pagamento" className="btn btn-thick btn-grey">
            Indietro
          </Link>
          <Link to="/checkout-success" className="btn btn-thick btn-primary">
            Conferma ordine
          </Link>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    cart: state.cart,
    isAuthenticated: state.user.authenticated,
    uiVariantButton: state.store.data.uiVariants.buttons,
  };
}

export default connect(mapStateToProps)(Riepilogo);
